import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Clock, Calendar, ClipboardList, Newspaper, User } from 'lucide-react';

const NAV_ITEMS = [
  { path: '/einsatzplan', icon: ClipboardList, label: 'Einsatz' },
  { path: '/vacations', icon: Calendar, label: 'Urlaub' },
  { path: '/zeiterfassung', icon: Clock, label: 'Zeiten' },
  { path: '/news', icon: Newspaper, label: 'News' },
  { path: '/mein-profil', icon: User, label: 'Profil' },
];

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border/40 lg:hidden safe-area-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-14 px-1">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
          const Icon = item.icon;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                isActive ? 'text-primary' : 'text-muted-foreground'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <Icon className={`h-5 w-5 ${isActive ? 'stroke-[2.5]' : ''}`} />
              <span className="text-[10px] font-medium leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
